<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Retorno Bancário</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="Processar()" :disabled="!valid">Processar</v-btn>
                    <v-btn dark text @click="Baixar()" :disabled="!valid">Baixar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formRetornoRecebivel" ref="formRetornoRecebivel" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="5">
                            <v-select v-model="item.banco" label="Banco" :items="bancos" return-object item-text="nome" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="">
                            <v-file-input show-size label="Arquivo de Retorno" v-model="arquivoRetorno" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>

                <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-center">Documento</th>
                        <th class="text-center">Doador</th>
                        <th class="text-center">Vencimento</th>
                        <th class="text-center">Pagamento</th>
                        <th class="text-center">Valor Título</th>
                        <th class="text-center">Juros</th>
                        <th class="text-center">Descontos</th>
                        <th class="text-center">Valor Pago</th>
                        <th class="text-center">Ocorrência</th>
                        <th class="text-center">Situação</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in detalhes" :key="item.numeroDocumento">
                        <td class="text-center">{{ item.numeroDocumento }}</td>
                        <td>{{ item.nomeSacado }}</td>
                        <td class="text-center">{{ item.dataVencimento ? new Date(item.dataVencimento).ddmmyyyy() : '' }}</td>
                        <td class="text-center">{{ item.dataCredito ? new Date(item.dataCredito).ddmmyyyy() : '' }}</td>
                        <td class="text-right">{{ item.valorTitulo.toMoeda() }}</td>
                        <td class="text-right">{{ item.juros.toMoeda() }}</td>
                        <td class="text-right">{{ item.descontos.toMoeda() }}</td>
                        <td class="text-right">{{ item.valorPago.toMoeda() }}</td>
                        <td>{{ item.descricaoOcorrencia.length > 0 ? item.descricaoOcorrencia : item.codigoOcorrencia }}</td>
                        <td class="text-center">
                            <v-chip class="my-2" v-if="item.situacao > 0" :style=" item.situacao == 1 ? 'background: var(--v-chipGreen-base) !important' : item.situacao == 2 ? 'background: var(--v-chipYellow-base) !important' : 'background: var(--v-chipRed-base) !important'">
                                <span style="font-weight: bold" :style=" item.situacao == 1 ? 'color: var(--v-chipFontGreen-base) !important' : item.situacao == 2 ? 'color: var(--v-chipFontYellow-base) !important' : 'color: var(--v-chipFontRed-base) !important'">
                                    {{ item.situacaoStr }}
                                </span>
                            </v-chip>
                        </td>
                    </tr>
                    </tbody>
                </template>
                </v-simple-table>


            </v-card-text>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import RecebivelService from '@/core/services/financeiro/RecebivelService';
import BoletoService from '@/core/services/financeiro/BoletoService';
import BancoService from '../../../core/services/financeiro/BancoService';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formRetornoRecebivel' in this.$refs){
                this.$refs.formRetornoRecebivel.resetValidation();
                this.log = '';
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (this.dialog) {
                this.Carregar();
            }
            else{
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new RecebivelService(),
        boletoService: new BoletoService(),
        bancoService: new BancoService(),
        mskMesAno: process.env.VUE_APP_MSK_MESANO,
        valid: true,
        dialog: false,
        isLoading: false,
        overlay: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        bancos: [],
        detalhes: [],
        arquivoRetorno: null
    }),
    methods: {
        Processar(){
            this.overlay = true;
            this.detalhes = [];
            this.boletoService.ProcessarRetorno(this.item.banco.bancoId, this.arquivoRetorno).then(
                res => {
                    var retorno = res.data;
                    retorno.forEach(x => {
                        if(new Date(x.DataCredito).getFullYear() < '1970')
                            x.DataCredito = null;
                    });
                    this.overlay = true;
                    this.service.VerificaRetorno(this.item.banco.bancoId, retorno).then(
                        res => {
                            this.detalhes = res.data;
                        }
                    ).finally(
                        () => this.overlay = false
                    );
                },
                err => {
                    if (err.response.status == 400) {
                        this.$swal('Aviso', err.response.data.messageDetauk, 'warning');
                    }
                    else {
                        this.$swal('Aviso', err.response.data.ExceptionMessage, 'error');
                    }
                }
            )
            .finally(
                () => this.overlay = false
            );
        },
        Baixar() {
            if (this.$refs.formRetornoRecebivel.validate()) {
                this.overlay = true;
                this.service.BaixarRetorno(this.item.banco.id, this.detalhes).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.Processar();
                        this.$emit('salvou');
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning');
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error');
                        }
                    }
                ).finally(
                    () => this.overlay = false
                );
            }

        },
        close() {
            this.dialog = false;
        },
        Carregar(){
            this.bancoService.Listar().then(
                res => {
                    this.bancos = res.data.items;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    }
}
</script>